export default __webpack_public_path__ + "7aa2233fb44bc3d9d60757a845e4adc2.png";